import { render, staticRenderFns } from "./adminManageUser.vue?vue&type=template&id=12993667"
import script from "./adminManageUser.vue?vue&type=script&lang=js"
export * from "./adminManageUser.vue?vue&type=script&lang=js"
import style0 from "./adminManageUser.vue?vue&type=style&index=0&id=12993667&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports